/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateOfBirth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DateOfBirth({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/DateOfBirth"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let patientPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.birth_date',
format: fromFormat.dateShortIn,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let patientPersonBirthDateValueData1 = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.birth_date',
format: fromFormat.dateShortIn,
})
  return (<React.Fragment
>
<div
  data-testid="DateOfBirth.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1vvCpo': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral900}
 text="Patient's DOB:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 marginLeft={dtSpaceXxs}
 data="patient.person.birth_date"
 format="/Data/format.js dateShortIn"
 text={patientPersonBirthDateValueData}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 data="patient.person.birth_date"
 format="/Data/format.js dateShortIn"
 value={patientPersonBirthDateValueData1}
 text="Copy date of birth"
/>
</div>
{children}
</React.Fragment>)
}